import { useRef, useState } from "react";
import {
  acceptFiles,
  ATTACHMENT_ERROR_COUNT,
  ATTACHMENT_MAX_FILES,
} from "@/features/conversations/attachments";

export function useAttachmentDraft(reservedSlots = 0) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [error, setError] = useState<string | null>(null);

  function openFilePicker() {
    if (reservedSlots + files.length >= ATTACHMENT_MAX_FILES) {
      setError(ATTACHMENT_ERROR_COUNT);
      return;
    }
    inputRef.current?.click();
  }

  function addFiles(list: FileList | null) {
    if (!list?.length) return;
    const result = acceptFiles(files, Array.from(list), reservedSlots);
    setFiles(result.files);
    setError(result.error);
    if (inputRef.current) inputRef.current.value = "";
  }

  function removeFile(index: number) {
    setFiles((prev) => prev.filter((_, i) => i !== index));
    setError(null);
  }

  function reset() {
    setFiles([]);
    setError(null);
  }

  return { inputRef, files, setFiles, error, setError, openFilePicker, addFiles, removeFile, reset };
}
